module.exports = "<section class=\"modal__social-slider js-modal\"> <div class=\"modal__background js-close\"></div> <div class=modal__content> <button class=\"modal__button--close cta js-close\">close</button> <ul class=\"modal__slider js-slider\"> {{#each items}} <li class=modal__slider-item> <a class=modal__thumb href={{url}} style=background-image:url({{img}}) data-index={{@index}} target=_blank>&nbsp;</a> </li> {{/each}} </ul> </div> </section> ";


//////////////////
// WEBPACK FOOTER
// ./templates/modals/social-slider.html
// module id = 62
// module chunks = 0